import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import classes from './CharacterWorld.module.css';
import CharacterCard from '../characterCard/CharacterCard';
import CharacterDescription from '../characterDescription/CharacterDescription';
import studentStars from '../../../../assets/characterWorld/studentStars.png';
import starsGroup from '../../../../assets/characterWorld/starsGroup.png';
import teacherStars from '../../../../assets/characterWorld/teacherStars.png';
import goldLeafRight from '../../../../assets/characterWorld/goldLeafRight.png';
import goldLeafLeft from '../../../../assets/characterWorld/goldLeafLeft.png';
import coins from '../../../../assets/characterWorld/logoCoins.png';
import myStarsDesktop from '../../../../assets/characterWorld/myStarsDesktop.png';
import myStarsMobile from '../../../../assets/characterWorld/myStarsMobile.png';
import nextStepStarsDesktop from '../../../../assets/characterWorld/nextStepStarsDesktop.png';
import BtnComponent from '../../../ui/buttons/BtnComponent';

const CharacterWorld = ({ 
  characters, 
  defaultCharacterId, 
  userStars, 
  starsRemaining, 
  button, 
  showStarsInfo, 
  showTeacherDecorations 
}) => {
  const [selectedCharacterId, setSelectedCharacterId] = useState(defaultCharacterId);
  const { texts } = useSelector(state => state.translate);

  const selectedCharacter = characters?.find(char => char.id === selectedCharacterId) || characters?.[0];

  if (!characters || characters.length === 0) {
    return null;
  }

  return (
    <div className={`${classes.characterWorld} ${showTeacherDecorations ? classes.teacher : classes.student}`} id="characters-block">
      <div className={`${classes.characterWorldBorder}`}>
        <img src={starsGroup} alt="starsGroup" className={classes.decorativeStars} />

        <div className={classes.innerContent}>
          <div className={classes.descriptionContainer}>
            {selectedCharacter && <CharacterDescription character={selectedCharacter} />}
          </div>
          <div className={classes.cardsContainer}>
            <div className={classes.headerSection}>
              <h1 className={classes.title}>
                {texts["characterWorld.title"]}
              </h1>
              {showStarsInfo && (
                <div className={classes.starsInfo}>
                  <div className={classes.starsBlock}>
                    <span className={classes.myStarsLabel}>
                      {texts.myStars}
                    </span>
                    <div className={classes.starsImageContainer}>
                      <img src={myStarsDesktop} alt="myStarsDesktop" className={classes.myStarsImageDesktop} />
                      <img src={myStarsMobile} alt="myStarsMobile" className={classes.myStarsImageMobile} />
                      <span className={classes.starsValue}>{userStars}</span>
                    </div>
                  </div>
                  <div className={classes.progressBlock}>
                    <span className={classes.progressLabel}>
                      {texts["characterWorld.pointsRemainingToNextStage.student"]}
                    </span>
                    <div className={classes.progressImageContainer}>
                      <img src={nextStepStarsDesktop} alt="nextStepStarsDesktop" className={classes.nextStepStarsImage} />
                      <span className={classes.progressValue}>{starsRemaining}</span>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className={classes.cardsGrid}>
              {characters.map((character, index) => (
                <CharacterCard
                  key={index}
                  character={character}
                  isSelected={character.id === selectedCharacterId}
                  isTeacher={showTeacherDecorations}
                  onClick={() => setSelectedCharacterId(character.id)}
                />
              ))}
            </div>
          </div>
        </div>
        
        {button && (
          <>
            <div className={classes.btnPlayContainer}>
              <BtnComponent
                type={button.type}
                className={classes.btnPlay}
              />
            </div>
            <img src={studentStars} alt="studentStars" className={classes.decorativeStudentStars} />
            <img src={coins} alt="coins" className={classes.coins} />
            <img src={goldLeafLeft} alt="laurel wreath" className={classes.goldLeafLeft} />
          </>
        )}
        
        {showTeacherDecorations && (
          <>
            <img src={goldLeafRight} alt="laurel wreath" className={classes.goldLeafRight} />
            <img src={teacherStars} alt="teacherStars" className={classes.decorativeTeacherStars} />
          </>
        )}
      </div>
    </div>
  );
};

export default CharacterWorld;

